// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  droidId: __t.u64().primaryKey().name("droid_id"),
  owner: __t.identity(),
  cls: __t.string(),
  hp: __t.f32(),
  maxHp: __t.f32().name("max_hp"),
  poolMilli: __t.i64().name("pool_milli"),
  bonusMilli: __t.i64().name("bonus_milli"),
  spentMilli: __t.i64().name("spent_milli"),
  fundedTotal: __t.i64().name("funded_total"),
  salesSov: __t.i64().name("sales_sov"),
  saleSeq: __t.u32().name("sale_seq"),
  saleSeen: __t.u32().name("sale_seen"),
  hurtSeq: __t.u32().name("hurt_seq"),
  hurtSeen: __t.u32().name("hurt_seen"),
  lastStepAt: __t.timestamp().name("last_step_at"),
  lastAdvertAt: __t.timestamp().name("last_advert_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
